// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"27feca3b","331":"ba624f41","583":"ba624f41","789":"9342e50c","930":"549a9cf4"}[chunkId] + ".chunk.css";
};